<span class="d-inline-flex align-items-center text-nowrap gap-small">
  @if (showLabel) {
    @if (href) {
      <a [class]="labelCssClass" [href]="href">{{ label }}</a>
    } @else {
      <span [class]="labelCssClass">{{ label }}</span>
    }
  }

  <web-design-system-icon
    name="copy"
    color="action"
    [class]="'ml-1 cursor-pointer ' + iconCssClass"
    [size]="iconSize"
    [copyText]="label"
    (copied)="displayCopiedIbanHint()"
    webDesignSystemCopyToClipboard
  />
</span>

<div class="copy-tooltip no-select" [class.active]="isActive">{{ hint }}</div>
